import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";
import { Checkbox, CheckboxProps, makeStyles, mergeClasses } from "@fluentui/react-components";
import { FluentProvider } from "@/dependencies";

interface CheckboxCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
  isField?: boolean;
  className?: string;
}

const useStyles = makeStyles({
  root: {
    "& label": {
      color: "var(--colorNeutralForeground1) !important",
    },
  },
  isField: {
    fontWeight: 600,
  },
});


const CheckboxCustom = (props: CheckboxCustomProps & CheckboxProps) => {
  const styles = useStyles();
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles,
  );

  const isDisabled = props.disabled || !isCanBeVisible;
  return props.theme ? (
    <FluentProvider theme={props.theme}>
      <Checkbox {...props} disabled={isDisabled} className={mergeClasses(styles.root, props.isField && styles.isField, props.className)} />
    </FluentProvider>
  ) : (
    <Checkbox {...props} disabled={isDisabled} className={mergeClasses(styles.root, props.isField && styles.isField, props.className)} />
  );
};

export default CheckboxCustom;
